"use client"

import { useEffect } from "react"

import { usePathname } from "next/navigation"

import { PSEUDO_ID_COOKIE } from "@/platform/api/constants"
import { isAppBridgeAvailable } from "@/platform/bridge/use-native-bridge"
import { getSessionCookie } from "@/platform/session/auth/get-session-cookie-client"

import { setDatadogPseudoId, setDatadogUserProperty } from "./context"
import { sampleLocation, startDatadog } from "./facade"

startDatadog()
const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)
if (pseudoId) setDatadogPseudoId(pseudoId)
setDatadogUserProperty("is_react_native_webview", isAppBridgeAvailable())

export const DatadogInit = () => {
  const pathname = usePathname()
  useEffect(() => sampleLocation(), [pathname])
  return null
}
